import { LoginButton, LoginWrapper, LoginFormMain } from './Atom'
import styles from "../../../styles/Login.module.css"
import { CircularProgress, TextField, Typography } from '@mui/material'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { useNavigate } from "react-router"

type ForgotPasswordProps = {
    loading: boolean,
    setForgotEmail: any,
    forgotEmailError: any,
    handleForgotPassword: any
}

const ForgotPassword = (props: ForgotPasswordProps) => {

    const { loading, setForgotEmail, forgotEmailError, handleForgotPassword } = props

    const navigate = useNavigate()

    return (
        <LoginWrapper>
            <h4 className={styles.LoginText}>FORGOT PASSWORD</h4>
            <LoginFormMain>
                <TextField
                    sx={{
                        marginTop: "0px",
                    }}
                    type="email"
                    error={forgotEmailError ? true : false}
                    helperText={forgotEmailError}
                    autoFocus
                    required
                    onChange={(e) => setForgotEmail(e.target.value)}
                    label="Email ID"
                    className={styles.TextInput}
                />
            </LoginFormMain>

            <LoginButton
                variant="contained"
                onClick={() => handleForgotPassword()}
                endIcon={loading ? <CircularProgress size={20} sx={{ color: "#FFFFFF" }} /> : <ArrowForwardIcon />}
            >
                <Typography style={{ textTransform: 'none' }} fontSize={16} fontWeight={500}>
                    Send OTP
                </Typography>
            </LoginButton>


        </LoginWrapper>
    )
}

export default ForgotPassword